module.exports = __webpack_public_path__ + "img/1.9.69315559.png";